// React

// Packages

// Utilities
import { useLabels, useMetricHelpers } from 'utilities/hooks';

// Components
import TagsAlt from 'components/tagsAlt';

const MetricComponent = ({ item }) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { label } = useLabels();
    const {
        hasTarget,
        getCurrentStatus,
        getTarget,
        getPostTitle,
        getTitle,
        isAudience,
    } = useMetricHelpers();

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <div className="grid grid-cols-8 p-16 space-y-12 bg-blue-20 md:space-y-0 md:space-x-24 md:items-center md:justify-between md:flex-ro rounded-8">
            {/* Metric */}
            <div className="flex flex-col justify-center col-span-5 shrink">
                {/* Pre title */}
                <span className="t-sh6 text-blue-60">{item.preTitle}</span>

                {/* Title */}
                <p className="mt-16 t-sh7 text-blue-60">
                    {label('MetricsTargetGroups')}
                </p>
                <h5 className="text-blue-100 truncate t-h5">
                    {getTitle(item, true)}
                </h5>

                {/* Post title */}
                {getPostTitle(item)?.length > 0 && (
                    <>
                        <p className="mt-16 mb-4 t-sh7 text-blue-60">
                            {label('MetricsOtherInformation')}
                        </p>
                        <div className="flex flex-col space-y-4 text-blue-100 t-footnote">
                            {getPostTitle(item)?.map((x, index) => (
                                <span key={index}>- {x}</span>
                            ))}
                        </div>
                    </>
                )}

                {/* Tagging */}
                {!isAudience(item) && item.tags.length > 0 && (
                    <TagsAlt
                        {...{
                            tags: item.tags,
                            theme: 'blue',
                            variant: 'darkest',
                            className: 'mt-12',
                        }}
                    />
                )}
            </div>
            {/* Result */}
            <div className="flex flex-col col-span-3 text-right">
                <h3 className="text-blue-100 t-h3">
                    {getCurrentStatus(item)}{' '}
                    {!hasTarget(item) ? null : (
                        <span className="text-blue-40">
                            / {getTarget(item)}
                        </span>
                    )}
                </h3>
                <p className="t-sh7 text-blue-60">
                    {label('MetricsReachedSoFar')}
                </p>
            </div>
        </div>
    );
};

export default MetricComponent;
